import { Folder } from "lucide-react";
import { cn } from "~/lib/utils";

interface PersonalDatasetIconProps {
  size?: number;
  className?: string;
}

// Mirrors DatasetIcon's bare-Folder rendering (no background chip), colored with
// the theme's primary purple rather than a per-dataset accent, since a personal
// dataset has no `accentColor` field.
export const PersonalDatasetIcon = ({ size = 24, className }: PersonalDatasetIconProps) => (
  <div
    className={cn("flex shrink-0 items-center justify-center text-primary", className)}
    style={{ width: size, height: size }}
    aria-hidden="true"
  >
    <Folder style={{ width: size, height: size }} fill="var(--color-purple-100)" />
  </div>
);
